import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CxHeartBeatModule } from '@bbraun/cortex/heart-beat';

import { SplashScreenComponent } from './splash-screen.component';


@NgModule({
  exports: [SplashScreenComponent],
  imports: [
    CommonModule,
    CxHeartBeatModule,
    SplashScreenComponent
  ]
})
export class SplashScreenModule { }
